<p>Подожите, происходит подтверждение доступа</p>
@if (hasErrors()) {
<p>Ошибка: {{ errors()?.token }}</p>
}
@if (nextButton() === 'goCabinet') {
<a routerLink="/cabinet/all/load/list">Перейти в кабинет</a>
}
@if (nextButton() === 'goSignIn') {
<a routerLink="/auth/sign-in">Перейти к авторизации</a>
}